<template>
  <div>
    <header v-if="acceptedRedistribution" class="modal-header">
      We are working to find you a pro that can better suit your needs and we have credited your
      account <span class="modal-header has-text-weight-bold">{{ amount }}</span>
    </header>

    <header v-else class="modal-header">We have credited your account {{ amount }}</header>
    <section class="modal-body">
      <h1>
        Once again we are sorry for the issue and look forward to making your lawn beautiful next
        time
      </h1>
    </section>
    <footer class="modal-footer">
      <LsButton text="ok" track-id="return_request_credit_applied-ok" @click="close" />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapState } from 'vuex';
import { lsFilters } from 'ls-vue-common';
import _ from 'lodash';

export default {
  name: 'ReturnRequestCreditApplied',
  components: {
    LsButton,
  },
  computed: {
    ...mapState(['dispute']),
    amount() {
      return lsFilters.currency({
        amount: this.dispute.currentDispute.credit_offered_amount,
        trimTrailingZeros: true,
      });
    },
    acceptedRedistribution() {
      return _.get(this.dispute.currentDispute, 'redistribution_accepted_at');
    },
  },
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
